import Byline from './Byline';

export default Byline;
